import uuid from 'react-uuid'

export const formatCreateAgentInput = async (
  agentValue: any,
  arrayOfAgentsToGetLeaderCode: any
) => {
  let agentArray = agentValue?.map(function (item: any) {
    if (item.id >= 0) {
      delete item.id
    }
    return item
  })
  if (agentArray.some((agent: any) => Boolean(agent.agentLeaderCode))) {
    agentArray = agentArray.map((agent: any) => {
      if (Boolean(agent.agentLeaderCode)) {
        return {
          ...agent,
          agentLeaderCode: arrayOfAgentsToGetLeaderCode.filter(
            ({ leaderCode }: any) => leaderCode === agent.agentLeaderCode
          )[0]?.leaderId,
        }
      } else {
        return agent
      }
    })
  }
  return agentArray
}
export const createAgentHelper = async (
  agentValue: any,
  arrayOfAgentsToGetLeaderCode: any,
  setGenerateTrackId: any,
  createAgents: any,
  uploadAgent: any,
  salesChannelId: any,
  createAgentsUsingUserIdAndPassword: any,
  activeStatus: boolean,
  uploadAgentUserPassword: any

) => {

  const agentArray = await formatCreateAgentInput(agentValue, arrayOfAgentsToGetLeaderCode)
  //call the createAgents API if agents < 10
  if (agentArray !== undefined && agentArray?.length <= 10) {
    const payload = agentArray.map((agent: any) => {
      
      return {
        ...(activeStatus && { emailId: agent?.agentEmailID }),
        firstName: agent?.agentFirstName,
        lastName: agent?.agentLastName,
        leaderId: agent?.agentLeaderCode ? agent?.agentLeaderCode : null,
        repId: agent?.agentRepId,
        ...(!activeStatus && { userName: agent?.UserName }),
        ...(!activeStatus && { password: agent?.agentPassword }),
      }
    })
    
    if (!activeStatus) {
      await createAgentsUsingUserIdAndPassword({
        variables: {
          createAgentInputs: payload,
          salesChannelId: salesChannelId,
        },
      })
    }
    else {
      await createAgents({
        variables: {
          createAgentInputs: payload,
          salesChannelId: salesChannelId,
        },
      })
    }
  }
  ///call the upload agents API if agents > 10
  if (agentArray !== undefined && agentArray?.length > 10) {
    const generatedTrackId = uuid()
    const uploadAgentPayload = agentArray.map((agent: any) => {
      return {
        ...(activeStatus && { agentEmailID: agent?.agentEmailID }),
        agentFirstName: agent?.agentFirstName,
        agentLastName: agent?.agentLastName,
        agentLeaderCode: agent?.agentLeaderCode ? agent?.agentLeaderCode : null,
        agentRepId: agent?.agentRepId,
        ...(!activeStatus && { userName: agent?.UserName }),
        ...(!activeStatus && { password: agent?.agentPassword }),
      }
    })
    setGenerateTrackId(generatedTrackId)
    if (activeStatus) {
      await uploadAgent({
        variables: {
          isVerified: true,
          salesChannelId: salesChannelId,
          trackId: generatedTrackId,
          userData: uploadAgentPayload,
        },
      })
    }
    else {
      await uploadAgentUserPassword({
        variables: {
          isVerified: true,
          salesChannelId: salesChannelId,
          trackId: generatedTrackId,
          userData: uploadAgentPayload,
        },
      })
    }
  }
}
